/* ==========================================================================
   SkinTalk.mx - Search Page JavaScript
   Custom element for search tab filtering on the main search results page.
   ========================================================================== */

if (!customElements.get('search-tabs')) {
  class SearchTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-filter]');
      this.resultsContainer = document.getElementById('search-results');

      if (!this.tabs.length || !this.resultsContainer) return;

      this.allItems = this.resultsContainer.querySelectorAll('[data-type]');
      this.bindEvents();
    }

    bindEvents() {
      var self = this;

      this.tabs.forEach(function(tab) {
        tab.addEventListener('click', function(e) {
          e.preventDefault();
          var filterType = this.getAttribute('data-filter');
          self.filterResults(filterType);
          self.setActiveTab(this);
        });
      });
    }

    /**
     * Filter results by type (all, product, article, page).
     * @param {string} type - The result type to show.
     */
    filterResults(type) {
      this.allItems.forEach(function(item) {
        var itemType = item.getAttribute('data-type');

        if (type === 'all' || itemType === type) {
          item.style.display = '';
          item.removeAttribute('hidden');
        } else {
          item.style.display = 'none';
          item.setAttribute('hidden', '');
        }
      });
    }

    /**
     * Set the active tab and update ARIA attributes.
     * @param {HTMLElement} activeTab - The tab to mark as active.
     */
    setActiveTab(activeTab) {
      this.tabs.forEach(function(tab) {
        tab.classList.remove('main-search__tab--active');
        tab.setAttribute('aria-selected', 'false');
      });

      activeTab.classList.add('main-search__tab--active');
      activeTab.setAttribute('aria-selected', 'true');
    }
  }

  customElements.define('search-tabs', SearchTabs);
}
